/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import StyleguideSection, {
  StyleguideSectionProps
} from "@/src/styleguide/components/StyleguideSection/StyleguideSection.tsx";
import { StyleguideInnerProps } from "@/src/styleguide/components/Styleguide/Styleguide.tsx";

export type StyleguideSectionRendererProps = { section: StyleguideInnerProps["sections"][0]; level?: StyleguideSectionProps["level"] };

export default function StyleguideSectionRenderer({ section, level = 1 }: StyleguideSectionRendererProps) {
  return (
    <StyleguideSection {...section} level={level}>
      {section.children}
      {section.subSections &&
        section.subSections.map((subSection) => <StyleguideSectionRenderer section={subSection} level={2} key={subSection.id} />)}
    </StyleguideSection>
  );
}
